'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name formSubmissionHandler
    * @description Handles form submission behavior including debouncing, submit button animations, and conversion tracking.
    * Options like:
         {
           enableAnimations = true,
           enableDebouncing = true
         };
    **/

    // Needs only be initialized once per page
    var initialize = function (optionOverrides) {
        var defaultOptions = {
            enableAnimations: true,
            enableDebouncing: true
        };
        optionOverrides = optionOverrides || {};
        var options = $.extend({}, defaultOptions, optionOverrides);

        registerCustomSubmitEvents();

        // animate and debounce regular contour forms
        var $regularSubmitButtons = $('input[type="submit"]:not([proxy-submit-for])');
        $regularSubmitButtons.on('click', function () {
            var $submitButton = $(this);
            var $form = $submitButton.closest('form');

            var isContourForm = $form.parent().hasClass('umbraco-forms-form');

            if (options.enableAnimations) {
                animateSubmitButton($submitButton, $form);
            }
            
            if (!isContourForm && options.enableDebouncing) {
                debounceForm($submitButton, $form);
            }
        });

        // animate and debounce proxy submit button forms
        var $proxySubmitButtons = $('input[type="submit"][proxy-submit-for]');
        $proxySubmitButtons.on('click', function () {
            var $submitButton = $(this);
            var proxyFormWrapperSelector = $submitButton.attr('proxy-submit-for');
            var $form = $(proxyFormWrapperSelector + ' form');
            if ($form.length > 0) {
                if (options.enableAnimations) {
                    animateSubmitButton($submitButton, $form);
                }
                
                if (options.enableDebouncing) {
                    debounceForm($submitButton, $form);
                }
                
                trySubmitProxyForm($form);
            }
        });        
    };

    var animateSubmitButton = function($submitButton, $form) {
        $submitButton.addClass('clicked');

        if ($form.length > 0) {
            $form.validate();
            if ($form.valid()) {
                setTimeout(function () {
                    $submitButton.removeClass("clicked");
                    $submitButton.addClass("validate");
                }, 1000);
            } else {
                $submitButton.removeClass("clicked");
            }
        }
    }

    var debounceForm = function($submitButton, $form) {
        $form.on('submit', function () {
            if ($form.length > 0) {
                $form.validate();
                if ($form.valid()) {
                    $submitButton.attr('disabled', 'disabled');
                } else {
                    $submitButton.removeAttr('disabled', 'disabled');
                }
            }
        });
    }

    var trySubmitProxyForm = function($form) {
        if ($form.length > 0) {
            $form.validate();
            if ($form.valid()) {
                $form.find('input[type="submit"]').click();
            }
        }
    }

    // Fire custom event when an UmbracoForm is successfully submitted
    // This allows other JS to attach to successful umbraco form submissions
    var registerCustomSubmitEvents = function () {
        $(".umbraco-forms-form input[type=submit]").not(".cancel").click(function (e) {
            var self = $(this);
            var frm = self.closest("form");
            frm.validate();
            if (frm.valid()) {
                var getoursFormSubmission = new Event('getours-form-submission');
                frm[0].dispatchEvent(getoursFormSubmission);
            }
        });
    }

    // Return an object exposing the public items
    return {
        initialize: initialize
    };

}())